import { render, staticRenderFns } from "./AdminTabelloneCronologiaView.vue?vue&type=template&id=c6326a18&"
import script from "./AdminTabelloneCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTabelloneCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports